import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useMyProfileSelector = () => useSelector((state: TAppState) => state.myProfileReducer);
